import service from '@/utils/request'
// 查询供应商联系方式
export function supplierContactsList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/supplierContactsList',
        data: param
    })
}
// 查询供应商联系方式 不分页
export function supplierContactsListAll() {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/list',
    })
}
// 新增供应商联系方式
export function addSupplierContacts(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/add',
        data: param
    })
}
// 修改供应商联系方式
export function editSupplierContacts(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/edit',
        data: param
    })
}

// 批量删除供应商联系方式
export function batchDelSupplierContacts(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/batchDel',
        data: param
    })
}



// 删除供应商联系方式
export function delSupplierContacts(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/del',
        data: param
    })
}
// 导出供应商联系方式
export function exportSupplierContacts(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierContacts/export',
        data: param
    })
}
